<header class="header">

	<section class="logo">
		<img src="/assets/images/kwo-logo-yellow.png" alt="Logo KWO" (click)="goToHome()">
	</section>

	<section class="menu">
		<kwo-menu></kwo-menu>
	</section>

	<section class="mobile-menu" *ngIf="showMobileMenu">
		<kwo-mobile-menu></kwo-mobile-menu>
	</section>

	<section class="account">

		<ng-container *ngIf="liveStreams$ | async as streams;">
			<div ngbDropdown class="live-stream" [container]="dropdownContainer" placement="bottom-end"
				*ngIf="streams.length > 0">

				<img class="notification" src="/assets/images/livestream.png" id="dropdownLiveStreams"
					ngbDropdownToggle />

				<div ngbDropdownMenu aria-labelledby="dropdownLiveStreams">
					<div ngbDropdownItem class="item" *ngFor="let stream of streams">
						<div class="cover">
							<div class="image-container portrait">
								<img [src]="stream.cover" alt="Live Stream Cover" />
							</div>
						</div>
						<div class="meta">
							<div class="title" [innerHTML]="stream.title"></div>
							<div class="description" [innerHTML]="stream.description"></div>

							<div class="actions">
								@if(stream.date) {
								<div class="date">
									<fa-icon [icon]="['far', 'clock']"></fa-icon>
									{{ stream.date }}
								</div>
								}
								<div class="link">
									@if(user && stream.link) {
									<a href="{{ stream.link }}" target="_blank">
										Open livestream
										<fa-icon matSuffix [icon]="['fas', 'arrow-up-right-from-square']"></fa-icon>
									</a>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<kwo-account-profile></kwo-account-profile>
	</section>

	<section class="mobile-toggle" (click)="toggleMobile()">
		<fa-icon class="toggle-menu" matSuffix [icon]="['fas', 'bars']" *ngIf="!showMobileMenu"></fa-icon>
		<fa-icon class="toggle-menu" matSuffix [icon]="['fas', 'times']" *ngIf="showMobileMenu"></fa-icon>
	</section>
</header>